import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLeadsViews } from '../../../lib/query/invalidateResource';
import { updateLead } from '../api/leads';
import type { LeadFormValues } from '../types';
import { notification } from 'antd';

export function useUpdateLead(leadId: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: LeadFormValues) => {
      if (!leadId) throw new Error('Lead ID is required');
      return updateLead(leadId, data);
    },
    onSuccess: () => {
      notification.success({ message: 'Lead updated successfully' });
      invalidateLeadsViews(queryClient);
      void queryClient.invalidateQueries({ queryKey: ['lead', leadId] });
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: Error) => {
      const msg = (error as any)?.response?.data?.detail
        ?? (error as any)?.response?.data?.title
        ?? error.message
        ?? 'Failed to update lead';
      notification.error({ message: msg });
    },
  });
}
